import { render, staticRenderFns } from "./product-picker.vue?vue&type=template&id=04a9add4&scoped=true&"
import script from "./product-picker.vue?vue&type=script&lang=js&"
export * from "./product-picker.vue?vue&type=script&lang=js&"
import style0 from "./product-picker.vue?vue&type=style&index=0&id=04a9add4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a9add4",
  null
  
)

export default component.exports